export default __webpack_public_path__ + "static/media/netvrk-v2-3.79ef0e8c.jpg";